export const notices = [
  {
    id: 1,
    title: '새로운 마음, 새로운 시작',
    date: '2026.07.01',
    summary: '다온심리상담센터의 비전과 방향성에 대한 안내',
  },
  {
    id: 2,
    title: '마음의 회복을 위한 동행',
    date: '2026.06.15',
    summary: '심리 지원 활동의 기본 방향과 철학',
  },
  {
    id: 3,
    title: '함께 만드는 건강한 공동체',
    date: '2026.05.20',
    summary: '지역사회 연계 활동의 의미와 목표',
  },
  {
    id: 4,
    title: '성장과 희망을 향한 걸음',
    date: '2026.04.10',
    summary: '개인의 회복과 성장을 돕는 심리 지원',
  },
  {
    id: 5,
    title: '정서적 안정을 위한 공간',
    date: '2026.03.05',
    summary: '따뜻하고 안전한 심리 지원 환경 조성',
  },
]